export class Timer {
	public start(){ this._startTime = new Date().getTime(); }
	public getElapsed(){ return ((new Date).getTime() - this._startTime); }
	private _startTime:number = 0;
}